import { isCnpj, isCpf } from 'utils/formataValidaDocumentos'
import refineDateValidation from 'utils/refineDataSchmeInputs'
import { ERROR_MESSAGE_SCHEMAS } from 'utils/variablesAndSelects'
import { z } from 'zod'

export const documentFilterSchema = z.object({
  dt_venda: z
    .object({
      dt_venda_inicial: z.date({
        required_error: ERROR_MESSAGE_SCHEMAS.required_error,
        invalid_type_error: ERROR_MESSAGE_SCHEMAS.invalid_date_type_error
      }),

      dt_venda_final: z.date({
        required_error: ERROR_MESSAGE_SCHEMAS.required_error,
        invalid_type_error: ERROR_MESSAGE_SCHEMAS.invalid_date_type_error
      })
    })
    .superRefine(refineDateValidation('dt_venda_inicial', 'dt_venda_final')),
  cd_inscricao_nacional: z
    .string()
    .optional()
    .refine((value) => !value || isCpf(value) || isCnpj(value), {
      message: 'Informe um CPF ou CNPJ válido'
    }),
  cpf_cnpj_comissionado: z
    .string()
    .optional()
    .refine((value) => !value || isCpf(value) || isCnpj(value), {
      message: 'Informe um CPF ou CNPJ válido'
    }),
  id_documento: z.object({
    id_documento_inicial: z
      .number()
      .optional()
      .nullable()
      .refine((val) => !val || val.toString().length <= 10, { message: 'Máximo de 10 dígitos' }),
    id_documento_final: z
      .number()
      .optional()
      .nullable()
      .refine((val) => !val || val.toString().length <= 10, { message: 'Máximo de 10 dígitos' })
  }),
  st_status: z.string({
    required_error: ERROR_MESSAGE_SCHEMAS.required_error,
    invalid_type_error: ERROR_MESSAGE_SCHEMAS.invalid_date_type_error
  })
})

export type DocumentFilterType = z.infer<typeof documentFilterSchema>
